import { render, staticRenderFns } from "./LabelGenEdit.vue?vue&type=template&id=857ff548"
import script from "./LabelGenEdit.vue?vue&type=script&lang=js"
export * from "./LabelGenEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports